<template>
  <v-card>
    <v-card-title class="grey--text text-subtitle-1">
      Specie
      <v-spacer></v-spacer>
      <v-btn outlined color="green" @click="$refs.nuova_specie.open()"
        ><v-icon class="mr-2">mdi-plus</v-icon> Aggiungi</v-btn
      >
      <NuovaSpecie ref="nuova_specie" />
    </v-card-title>
    <v-card-text>
      <v-row>
        <v-col cols="4">
          <v-text-field
          class="ml-6"
            v-model="filtro"
            label="Filtra specie"
            prepend-inner-icon="mdi-magnify"
            clearable
            outlined
            :error="filtroNonValido"
            :error-messages="filtroNonValido ? 'Regex non valida' : ''"
          />
        </v-col>
      </v-row>
      <v-list>
        <SpecieElement
          v-for="specie in specieFiltered"
          :specie="specie"
          :key="specie.id"
        />
      </v-list>
    </v-card-text>
  </v-card>
</template>

<script>
import NuovaSpecie from "./nuova_specie_dialog.vue";
import SpecieElement from "./specie_element.vue";
export default {
  components: {
    NuovaSpecie,
    SpecieElement,
  },
  data() {
    return {
      filtro: "",
    };
  },
  computed: {
    species() {
      return this.$store.getters.get_specie.slice().sort((a, b) =>
        a.nome.localeCompare(b.nome)
      );
    },
    filtroNonValido() {
      if (!this.filtro) return false;
      try {
        new RegExp(this.filtro, "i");
        return false;
      } catch {
        return true;
      }
    },
    specieFiltered() {
      if (!this.filtro || this.filtroNonValido) return this.species;
      const re = new RegExp(this.filtro, "i");
      return this.species.filter((s) => re.test(s.nome));
    },
  },
  methods: {},
};
</script>